export default "__VITE_ASSET__DFNuJtbR__"